import { usePlanCardContext } from '@aibees/shared/features/plan-card/context';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames, fDate } from '@aibees/shared/utils';
import { CardContent, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { RecommendationProps as Props } from './types';

export const Recommendation = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();
  const { selectedPlan } = usePlanCardContext();
  const currentPlan = data?.current?.plan;

  const isDowngradingToFree = selectedPlan?.metadata.is_free === 'true';

  const isDowngradingToLowerPaid =
    !isDowngradingToFree &&
    (currentPlan?.interval === selectedPlan?.interval ||
      (currentPlan?.interval === 'MONTH' &&
        selectedPlan?.interval === 'YEAR')) &&
    Number(currentPlan?.metadata.request) >
      Number(selectedPlan?.metadata.request);

  return (
    <Styled.Wrapper
      className={classnames('Recommendation', className)}
      sx={SX.root}
      variant="outlined"
    >
      <CardContent padding="normal" sx={SX.cardContent}>
        <Typography variant="body3" color="grey.700" fontWeight={500}>
          Recommendation
        </Typography>
        <Divider sx={SX.divider} />
        <Typography variant="body4" fontWeight={400} color="common.black">
          {isDowngradingToLowerPaid ? (
            <>
              Consider downgrading to a lower paid Plan with a higher Roll Over
              Credit to not lose any existing Credit balance.
            </>
          ) : (
            <>
              If unable to use all credits by {'  '}
              <Typography
                component="span"
                variant="body4"
                fontWeight={700}
                color="common.black"
              >
                {fDate(data?.current?.currentPeriodEnd)}
              </Typography>
              , consider downgrading
              <br /> to a lower paid plan to retain more balance.
            </>
          )}
        </Typography>
      </CardContent>
    </Styled.Wrapper>
  );
});

Recommendation.displayName = 'Recommendation';
